<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 48 48"><title>{{title}}</title>
    <g :fill="fill">
      <g class="loop-circle">
        <path d="M24 47a23 23 0 1 1 23-23 23.025 23.025 0 0 1-23 23zm0-42a19 19 0 1 0 19 19A19.021 19.021 0 0 0 24 5z" opacity=".4"></path>
        <path d="M47 24h-4A19.021 19.021 0 0 0 24 5V1a23.025 23.025 0 0 1 23 23z"></path>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    fill: {
      type: String,
      default: 'currentColor',
    },
    title: {
      type: String,
      default: 'Chargement',
    },
    size: {
      type: Number,
      default: 24,
    },
  },
}
</script>

<style scoped>
.loop-circle {
  --animation-duration: 0.65s;
  transform-origin: 24px 24px;
  animation: loop-circle-anim var(--animation-duration) infinite cubic-bezier(.645, .045, .355, 1)
}

@keyframes loop-circle-anim {
  0% {
    transform: rotate(0)
  }
  100% {
    transform: rotate(360deg)
  }
}
</style>
